// PREZENCE — HR Dashboard (FIXED: pending leaves now links to /hr/leaves)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/client';
import toast from 'react-hot-toast';

const getInitials = n => (n||'').split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();

export default function HRDashboard() {
  const navigate = useNavigate();
  const [pending, setPending] = useState([]);
  const [stats, setStats] = useState({ pendingLeaves:0, approvedToday:0, rejectedToday:0, onLeaveToday:0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/leaves/pending').then(r => setPending(r.data.data || [])),
      api.get('/dashboard/hr').then(r => setStats(r.data.stats || {})),
    ])
      .catch(() => toast.error('Failed to load dashboard'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ animation:'fadeIn 0.4s ease' }}>
      <div className="page-header">
        <h1 className="page-title">HR Dashboard</h1>
        <p className="page-sub">Manage leave requests and employee information</p>
      </div>
      <div className="grid-4" style={{ marginBottom:24 }}>
        {[
          { label:'Pending Leaves', value: stats.pendingLeaves, color:'#f59e0b', icon:'⏳', click: () => navigate('/hr/leaves') },
          { label:'Approved Today', value: stats.approvedToday, color:'#22c55e', icon:'✓' },
          { label:'Rejected Today', value: stats.rejectedToday, color:'#ef4444', icon:'✕' },
          { label:'On Leave Today', value: stats.onLeaveToday, color:'#a78bfa', icon:'◧' },
        ].map((s,i) => (
          <div key={i} className="card" style={{ padding:'18px 20px', cursor: s.click ? 'pointer' : 'default' }} onClick={s.click}>
            <div style={{ display:'flex', justifyContent:'space-between' }}>
              <div>
                <p style={{ fontSize:10, color:'#475569', letterSpacing:'0.1em', fontFamily:"'JetBrains Mono'", marginBottom:8 }}>{s.label.toUpperCase()}</p>
                <p style={{ fontSize:28, fontWeight:800, color:s.color, fontFamily:"'JetBrains Mono'" }}>{s.value}</p>
              </div>
              <span style={{ fontSize:20, color:s.color, opacity:0.4 }}>{s.icon}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">PENDING LEAVE REQUESTS</span>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <span className="badge badge-amber">{pending.length} pending</span>
            {/* FIX: button now navigates to correct leave approvals page */}
            <button className="btn btn-primary btn-sm" onClick={() => navigate('/hr/leaves')}>
              Review All →
            </button>
          </div>
        </div>
        {loading ? (
          <div style={{ display:'flex', justifyContent:'center', padding:40 }}><div className="spinner" style={{width:24,height:24}} /></div>
        ) : pending.length === 0 ? (
          <div className="empty-state"><div className="empty-state-icon">✅</div><div className="empty-state-text">No pending leave requests</div></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Employee</th><th>Leave Type</th><th>From</th><th>To</th><th>Days</th><th>Reason</th><th>Applied</th><th></th></tr></thead>
              <tbody>
                {pending.map(l => (
                  <tr key={l.id} style={{ cursor:'pointer' }} onClick={() => navigate('/hr/leaves')}>
                    <td>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div className="avatar avatar-sm">{getInitials(l.users?.full_name)}</div>
                        <div>
                          <div style={{ fontWeight:600, color:'#e2e8f0', fontSize:13 }}>{l.users?.full_name}</div>
                          <div style={{ fontSize:10, color:'#475569' }}>{l.users?.department}</div>
                        </div>
                      </div>
                    </td>
                    <td><span style={{ fontSize:12, color:'#94a3b8' }}>{l.leave_types?.name}</span></td>
                    <td style={{ fontFamily:"'JetBrains Mono'", fontSize:12 }}>{new Date(l.from_date).toLocaleDateString('en-IN',{day:'numeric',month:'short'})}</td>
                    <td style={{ fontFamily:"'JetBrains Mono'", fontSize:12 }}>{new Date(l.to_date).toLocaleDateString('en-IN',{day:'numeric',month:'short'})}</td>
                    <td style={{ fontFamily:"'JetBrains Mono'", fontWeight:700, color:'#63dcbc' }}>{l.total_days}</td>
                    <td style={{ maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12 }}>{l.reason}</td>
                    <td style={{ fontSize:11, color:'#475569', fontFamily:"'JetBrains Mono'" }}>{new Date(l.applied_at).toLocaleDateString('en-IN',{day:'numeric',month:'short'})}</td>
                    <td><button className="btn btn-primary btn-sm" onClick={e => { e.stopPropagation(); navigate('/hr/leaves'); }}>Review</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
